import slActions from "./slActions";

export default slActions;
